import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

// Get analytics overview
export const getAnalyticsAction = createAsyncThunk(
  "analytics/getAnalytics",
  async (days = 30, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.ANALYTICS.GET_OVERVIEW(days)
      );

      if (!response.success) {
        return rejectWithValue(response.error || "Failed to fetch analytics");
      }

      return {
        analytics: response.analytics,
        days,
      };
    } catch (error) {
      console.error("Analytics fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch analytics"
      );
    }
  }
);

// Get user statistics
export const getUserStatsAction = createAsyncThunk(
  "analytics/getUserStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.ANALYTICS.GET_USER_STATS
      );

      if (!response.success) {
        return rejectWithValue(
          response.error || "Failed to fetch user statistics"
        );
      }

      return response.data;
    } catch (error) {
      console.error("User stats fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch user statistics"
      );
    }
  }
);

// Get revenue statistics
export const getRevenueStatsAction = createAsyncThunk(
  "analytics/getRevenueStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.ANALYTICS.GET_REVENUE_STATS
      );

      if (!response.success) {
        return rejectWithValue(
          response.error || "Failed to fetch revenue statistics"
        );
      }

      return response.data;
    } catch (error) {
      console.error("Revenue stats fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch revenue statistics"
      );
    }
  }
);

// Get subscription statistics
export const getSubscriptionStatsAction = createAsyncThunk(
  "analytics/getSubscriptionStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.ANALYTICS.GET_SUBSCRIPTION_STATS
      );

      if (!response.success) {
        return rejectWithValue(
          response.error || "Failed to fetch subscription statistics"
        );
      }

      return response.data;
    } catch (error) {
      console.error("Subscription stats fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch subscription statistics"
      );
    }
  }
);

// Get usage statistics
export const getUsageStatsAction = createAsyncThunk(
  "analytics/getUsageStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.ANALYTICS.GET_USAGE_STATS
      );

      if (!response.success) {
        return rejectWithValue(
          response.error || "Failed to fetch usage statistics"
        );
      }

      return response.data;
    } catch (error) {
      console.error("Usage stats fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch usage statistics"
      );
    }
  }
);

// Get recent activity
export const getRecentActivityAction = createAsyncThunk(
  "analytics/getRecentActivity",
  async (weeks = 1, { rejectWithValue }) => {
    try {
      const days = weeks * 7;
      const response = await apiService.get(
        API_ENDPOINTS.ANALYTICS.GET_RECENT_ACTIVITY(days)
      );

      if (!response.success) {
        return rejectWithValue(
          response.error || "Failed to fetch recent activity"
        );
      }

      return {
        activity: response,
        weeks,
      };
    } catch (error) {
      console.error("Recent activity fetch error:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch recent activity"
      );
    }
  }
);
